export interface BusinessUnit {
  id: string;
  name: string;
  code: number;
}

export default class ResultCenter {
  id: string;

  name: string;

  businessUnit: BusinessUnit;

  active: boolean;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.businessUnit = obj.businessUnit;
    this.active = obj.active;
  }
}
